import { Component, OnDestroy, OnInit, ViewChild, Inject, afterNextRender } from '@angular/core';
import { MatTable, MatTableDataSource, MatTableModule } from "@angular/material/table";
import { Router } from "@angular/router";
import { AppointmentsService } from '../../services/appointments/appointments.service.js';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { Subscription } from "rxjs";
import { AppointmentsControls } from "./appointments-controls/appointments-controls.component";
import { MatSortModule } from "@angular/material/sort";
import { AppointmentFrontendRow, DataUtil, SortEvent } from 'allai-admin-shared';
import { AppointmentsFilterService } from '../../services/appointments/appointments-filter.service.js';

/** The appointments list page */
@Component({
	selector: 'app-appointments',
	imports: [
		MatTableModule,
		MatIconModule,
		MatButtonModule,
		AppointmentsControls,
		MatSortModule
	],
	templateUrl: './appointments.component.html',
	styleUrl: './appointments.component.scss'
})
export class AppointmentsComponent implements OnInit, OnDestroy {

	/** Columns in the table */
	readonly displayedColumns: (keyof AppointmentFrontendRow)[] = ['appointmentId', 'surveyId', 'patientId', 'mrn', 'firstName', 'lastName', 'organizationId', 'organizationName', 'appointmentTime', 'appointmentType', 'providerId', 'providerFirstName', 'providerLastName', 'userAgent'];

	/** Data source for the table */
	dataSource: MatTableDataSource<AppointmentFrontendRow>;

	static scrollToAppointmentStorageKey: string = 'scroll-to-appointment';

	/** Current search filter being applied */
	private _searchFilter: string;

	/** Table on the page showing the appointments */
	@ViewChild(MatTable)
	private table: MatTable<AppointmentFrontendRow>;

	/** Subscription for new appointments being loaded from filters */
	private newAppointmentsSub: Subscription;

	@ViewChild(AppointmentsControls)
	private appointmentControls: AppointmentsControls;

	constructor(private appointmentsService: AppointmentsService,
		private appointmentsFilterService: AppointmentsFilterService,
		private router: Router) {
	}

	ngOnInit() {
		this.newAppointmentsSub = this.appointmentsService.onNewAppointments.subscribe(() => {
			this.refresh();
		});

		this.appointmentsService.resolveAppointments();
	}

	private refresh() {

		const appointments = this.appointmentsService.appointmentList;

		this.appointmentControls.setTotal(this.appointmentsService.total);
		const rows: AppointmentFrontendRow[] = appointments.flatMap(value => DataUtil.toFrontEndRow(value));
		//make sure to re-render table
		this.dataSource = new MatTableDataSource<AppointmentFrontendRow>(rows);
		this.table?.renderRows();
	}

	ngOnDestroy() {
		this.newAppointmentsSub?.unsubscribe();
	}

	/** Open an appointment that was clicked on */
	goto(row: AppointmentFrontendRow) {
		let url = this.router.serializeUrl(this.router.createUrlTree(['/', 'appointments', row.appointmentId]));
		window.open(url, `_appointment_${row.appointmentId}`);
	}

	/** Current search filter being applied */
	set searchFilter(value: string) {
		this._searchFilter = value;
		this.dataSource.filter = this._searchFilter.trim().toLowerCase();

		if (this.dataSource.paginator) {
			this.dataSource.paginator.firstPage();
		}
	}

	formatDate(date: string): string {
		return new Date(date).toLocaleString();
	}

	sortData(sortEvent: SortEvent) {
		this.appointmentsFilterService.sortOrder = sortEvent
	}
}
